import React, { createContext, useContext, useState, useCallback } from 'react';

interface GrowthMetricDialogContextType {
  isOpen: boolean;
  growthPillarId: string | null;
  brandId: string | null;
  onSuccessCallback: (() => void) | null;
  openAddMetric: (pillarId: string, brandId: string, onSuccess?: () => void) => void;
  closeMetricDialog: () => void;
}

const GrowthMetricDialogContext = createContext<GrowthMetricDialogContextType | undefined>(undefined);

export const GrowthMetricDialogProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [growthPillarId, setGrowthPillarId] = useState<string | null>(null);
  const [brandId, setBrandId] = useState<string | null>(null);
  const [onSuccessCallback, setOnSuccessCallback] = useState<(() => void) | null>(null);

  const openAddMetric = useCallback((pillarId: string, brandId: string, onSuccess?: () => void) => {
    setGrowthPillarId(pillarId);
    setBrandId(brandId);
    setOnSuccessCallback(() => onSuccess || null);
    setIsOpen(true);
  }, []);

  const closeMetricDialog = useCallback(() => {
    setIsOpen(false);
    setGrowthPillarId(null);
    setBrandId(null);
    setOnSuccessCallback(null);
  }, []);

  return (
    <GrowthMetricDialogContext.Provider 
      value={{ 
        isOpen, 
        growthPillarId,
        brandId,
        onSuccessCallback,
        openAddMetric, 
        closeMetricDialog 
      }}
    >
      {children}
    </GrowthMetricDialogContext.Provider>
  );
};

export const useGrowthMetricDialog = () => {
  const context = useContext(GrowthMetricDialogContext);
  if (context === undefined) {
    throw new Error('useGrowthMetricDialog must be used within a GrowthMetricDialogProvider');
  }
  return context;
};
